module.exports = __webpack_public_path__ + "img/icon_used.ac03393e.png";